/**
 * Calendar date in the user's local timezone as `YYYY-MM-DD`.
 * Prefer this over `date.toISOString().slice(0, 10)` for API payloads: ISO strings are UTC and
 * can shift the calendar day for positive offsets (e.g. TR selecting the 26th → UTC 25th).
 */
export function formatLocalDateYYYYMMDD(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}
